import { AbyssTheme as themeConfiguration } from '@src/app/browser';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Text } from '@uhg-abyss/web/ui/Text';
import React from 'react';

/**
 * Tooltip; AdditionalCriteria
 *
 * @param filter
 * @param getFilter
 * @param getLabel
 * @param getValue
 * @returns {Element}
 * @constructor
 */
export function AdditionalCriteria({ filter, getFilter, getLabel, getValue }) {
  return (
    <Layout.Stack alignItems="left" alignLayout="left" grow space={Number(themeConfiguration?.theme?.space?.xs) || 4}>
      <div>
        <strong>{getFilter(filter?.column)}</strong>
      </div>
      <div>
        <p>{getLabel(filter?.condition)}:</p>
        <Text color="inherit">{getValue(filter?.value)}</Text>
      </div>
    </Layout.Stack>
  );
}
